import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchAvailableDates = () => async (dispatch) => {
  dispatch(fetchDatesPending());
  try {
    const response = await axios.get('/api/available-dates');
    dispatch(fetchDatesSuccess(response.data));
  } catch (error) {
    dispatch(fetchDatesError(error.message));
  }
};

const dateSlice = createSlice({
  name: 'dates',
  initialState: {
    available: [],
    status: 'idle',
    error: null,
  },
  reducers: {
    fetchDatesPending: (state) => {
      state.status = 'loading';
    },
    fetchDatesSuccess: (state, action) => {
      state.status = 'succeeded';
      state.available = action.payload;
    },
    fetchDatesError: (state, action) => {
      state.status = 'failed';
      state.error = action.payload;
    },
  },
});

export const { fetchDatesPending, fetchDatesSuccess, fetchDatesError } = dateSlice.actions;

export default dateSlice.reducer;
